/**
 * Predefined (static) section and fields for the Candidate Approval form.
 * Shown in the Candidate Approval Form Builder as read-only rows (with active +
 * mandatory/optional toggles) and rendered with their bespoke widgets in the live
 * CandidateApprovel form. Admin-built custom field values are stored in customFields.
 */

export const CA_PREDEFINED_SECTION_KEY = "predefined_candidate_info";
export const CA_PREDEFINED_SECTION_NAME = "Candidate Information";

export const CA_PREDEFINED_SECTION = {
  _id: "predefined_section",
  sectionName: CA_PREDEFINED_SECTION_NAME,
  sectionKey: CA_PREDEFINED_SECTION_KEY,
  isDefault: true,
  isPredefined: true,
  order: -1,
};

/**
 * Predefined fields mirror the current hardcoded CandidateApprovel form.
 * Shape: { fieldName, fieldLabel, fieldType, required, order, options? }
 * `required` here is the built-in default; admins can override per company via
 * the predefinedFieldsRequired map (mandatory/optional radio).
 */
export const CA_PREDEFINED_FIELDS = [
  { fieldName: "first_name", fieldLabel: "First Name", fieldType: "text", required: true, order: 0, locked: true },
  { fieldName: "last_name", fieldLabel: "Last Name", fieldType: "text", required: true, order: 1, locked: true },
  { fieldName: "email", fieldLabel: "Email", fieldType: "email", required: true, order: 2, locked: true },
  { fieldName: "business_unit", fieldLabel: "Business Unit", fieldType: "select", required: false, order: 3 },
  { fieldName: "business_head", fieldLabel: "Business Head", fieldType: "select", required: false, order: 4 },
  { fieldName: "interview_feedback", fieldLabel: "Interview Feedback", fieldType: "textarea", required: false, order: 5 },
  {
    fieldName: "experience",
    fieldLabel: "Fresher/Exp.",
    fieldType: "select",
    required: true,
    options: [
      { key: "Fresher", value: "Fresher" },
      { key: "Experience", value: "Experience" },
      { key: "Intern", value: "Intern" },
    ],
    order: 6,
    locked: true,
  },
  { fieldName: "designation_id", fieldLabel: "Designation", fieldType: "select", required: true, order: 7, locked: true },
  { fieldName: "department_id", fieldLabel: "Department", fieldType: "select", required: true, order: 8, locked: true },
  { fieldName: "sub_department_id", fieldLabel: "Sub-Department", fieldType: "select", required: false, order: 9 },
  { fieldName: "function_role_id", fieldLabel: "Function/role", fieldType: "select", required: false, order: 10 },
  { fieldName: "interview_date", fieldLabel: "Interview Date", fieldType: "date", required: true, order: 11 },
  { fieldName: "annual_current_salary", fieldLabel: "Current Annual Salary (₹)", fieldType: "number", required: false, order: 12 },
  { fieldName: "annual_offerd_salary", fieldLabel: "Offered Annual Salary", fieldType: "number", required: true, order: 13, locked: true },
  { fieldName: "salary_hike", fieldLabel: "Salary Hike (%)", fieldType: "number", required: false, order: 14 },
];
